import React from 'react'
import { Form , Row, Col , Input } from 'antd';


 export default function ContactDetails(props){

    return (<div style={{padding:"50px"}}> 
         
    <Row type="flex"  gutter={5} >  
        <Col span={3}>              
              
                <Form.Item label="No"> 
               
                    <Input name="address_no_input" value={props.employee.address_no}  onChange={props.handleChange}></Input>
                
                </Form.Item>
        </Col>
        <Col span={6}>
        <Form.Item label="Street">
            <Input name="address_street_input" value={props.employee.address_street} onChange={props.handleChange}></Input>
        </Form.Item>
        </Col>
        </Row>
        <Row type="flex"  gutter={5}> 
        <Col span={6}>
        <Form.Item label="Town">
            <Input name="address_town_input" value={props.employee.address_town} onChange={props.handleChange}></Input>
        </Form.Item>
        </Col>
        <Col span={6}>
        <Form.Item label="District">
            <Input name="address_district_input" value={props.employee.address_district} onChange={props.handleChange}></Input>
        </Form.Item>
        </Col>
    </Row>

   
  <Row type="flex"  >    
    <Col  span={6} >
          <Form.Item label="Contact No">               
            <Input name="contact_no_input" value={props.employee.contact_no}   onChange={props.handleChange}></Input>
          </Form.Item>
    </Col>
    
  </Row>

</div>)

}